import moment from "moment"

/**
 * Ensures any supplied time is formatted as UTC time.
 *
 * @param  {Object} timeString  A string representing a time.
 * @return {Object}             A string of the date transformed to UTC.
 */
export const applyUTC = (timeString) => moment.utc(timeString).toISOString()
